import EpisodeNumber from './EpisodeNumber';

const { registerPlugin } = wp.plugins;

/**
 * Registers 'idg-base-theme-start-date-link-blogseries' plugin in the Posts Settings Sidebar.
 */
wp.domReady(() => {
	registerPlugin('ib-wow-podcast-episode-number', {
		render: EpisodeNumber,
		icon: '',
	});
});
